import $ from "jquery";
import "3pp/pivot";

const nf = $.pivotUtilities.numberFormat;
const tpl = $.pivotUtilities.aggregatorTemplates;
const svFmt = nf({
    thousandsSep: " ",
    decimalSep: ","
});
const svFmtInt = nf({
    digitsAfterDecimal: 0,
    thousandsSep: " ",
    decimalSep: ","
});
const svFmtPct = nf({
    digitsAfterDecimal: 1,
    scaler: 100,
    suffix: "%",
    thousandsSep: " ",
    decimalSep: ","
});

$.pivotUtilities.locales.sv = {
    localeStrings: {
        renderError: "Ett fel uppstod när pivottabellens resultat skulle skapas",
        computeError: "Ett fel uppstod när pivottabellens resultat skulle beräknas",
        uiRenderError: "Ett fel uppstod när pivottabellen skulle skapas",
        selectAll: "Markera alla", //changes to add css styling as per #907434
        selectNone: "Välj ingen",
        tooMany: "För mycket i listan",
        filterResults: "Filtrera resultat",
        totals: "Antal",
        uniquetotals: "Unika Antal",
        uniqueTotalByPersonid: "Summa av unika förekomster",
        vs: "per",
        by: "och",
        cancel: "Avbryt", //changes to add css styling as per #907434
        apply: "Spara" //changes to add css styling as per #907434
    },
    aggregators: {
        "Antal förekomster": tpl.count(svFmtInt),
        "Antal unika förekomster": tpl.countUnique(svFmtInt),
        "Summa decimal": tpl.sum(svFmt),
        "Summa heltal": tpl.sum(svFmtInt) //Changes to add integer sum aggregator
    },
    renderers: {
        Tabell: $.pivotUtilities.renderers["Table"]
    }
};

window.define('flow/configuration/pivotTableInitializer-sv', [], function() { return __webpack_module__.exports; });